import { ChevronsDown } from "lucide-react";

interface PageBannerProps {
  title: string;
  image?: string;
}

export function PageBanner({ title, image }: PageBannerProps) {
  return (
    <section
      className="relative bg-ink text-white"
      style={
        image
          ? {
              backgroundImage: `linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.55)), url(${image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }
          : undefined
      }
    >
      <div className="container mx-auto px-4 py-24 md:py-32 flex flex-col items-center text-center">
        <h1 className="font-display font-bold uppercase text-4xl md:text-5xl tracking-wide text-white">
          {title}
        </h1>
        <ChevronsDown className="mt-6 h-7 w-7 text-brand" />
      </div>
    </section>
  );
}
